import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';

import { DynamicFieldComponent } from './dynamic-field.component';
import { BooleanInputComponent } from './dynamic-input/boolean-input';
import { FontSizeCssInputComponent } from './dynamic-input/font-size-css-input/font-size-css-input.component';
import { DateInputComponent } from './dynamic-input/date-input';
import { DynamicInputComponent } from './dynamic-input/dynamic-input.component';
import { EnumInputComponent } from './dynamic-input/enum-input';
import { IntegerInputComponent } from './dynamic-input/integer-input';
import { NumberInputComponent } from './dynamic-input/number-input';
import { RadioGroupInputComponent } from './dynamic-input/radio-group-input/radio-group-input.component';
import { TextareaInputComponent } from './dynamic-input/textarea/textarea.component';

import { SfoAdmonitionComponent } from '../../widgets';
import { HandleSchemaTypePipe } from './handle-schema-type.pipe';
import { HasEnumPipe } from './has-enum.pipe';
import { HasMultipleKeysPipe } from './has-multiple-keys.pipe';
import { ObjectNotEmptyPipe } from './object-not-empty.pipe';
import { UnsortedKeyvaluePipe } from './unsorted-key-value.pipe';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatTooltipModule,
    SfoAdmonitionComponent,
    HasEnumPipe,
    ObjectNotEmptyPipe,
    DynamicFieldComponent,
    BooleanInputComponent,
    DynamicInputComponent,
    EnumInputComponent,
    FontSizeCssInputComponent,
    DateInputComponent,
    IntegerInputComponent,
    NumberInputComponent,
    UnsortedKeyvaluePipe,
    HasMultipleKeysPipe,
    HandleSchemaTypePipe,
    TextareaInputComponent,
    RadioGroupInputComponent,
  ],
  exports: [
    DynamicFieldComponent,
    BooleanInputComponent,
    DynamicInputComponent,
    EnumInputComponent,
    FontSizeCssInputComponent,
    DateInputComponent,
    IntegerInputComponent,
    NumberInputComponent,
  ],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'fill' },
    },
    provideMomentDateAdapter({
      parse: {
        dateInput: 'YYYY-MM-DD',
      },
      display: {
        dateInput: 'YYYY-MM-DD', // <-- for displaying
        monthYearLabel: 'YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'YYYY',
      },
    }),
  ],
})
export class DynamicFieldModule {}
